"use client";

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import Autoplay from "embla-carousel-autoplay";
import Link from "next/link";

export interface FacilityHighlightProps {
  id: string;
  description: string;
  company_logo: string;
  facility: {
    id: string;
    title: string;
    description: string;
    thumbnail: string;
  }[];
}
export default function FacilityHighlight(props: FacilityHighlightProps) {
  return (
    <div className="py-12 xl:py-32 bg-darkgold relative overflow-hidden">
      <div className="w-full xl:max-w-screen-xl mx-auto">
        <img
          src="/homepage/stempel.svg"
          alt="logo"
          className="absolute -top-1/6 -left-1/12 z-10  hidden xl:block"
        />

        <img
          src="/homepage/stempel.svg"
          alt="logo"
          className="absolute top-3/12 -right-10  hidden xl:block"
        />

        <div className="px-20 xl:px-0">
          <p
            dangerouslySetInnerHTML={{ __html: props.description }}
            className="text-[13px] xl:text-3xl xl:leading-12 text-white text-center"
          ></p>
        </div>

        <Link
          href="https://www.sinarmasland.com/"
          target="_blank"
          className="z-[1] relative"
        >
          <img
            src={props.company_logo}
            className="mx-auto xl:my-24 object-contain w-[7rem] xl:w-[20rem] h-[7.75rem] xl:h-[6.5rem]"
            alt=""
          />
        </Link>

        <div className="hidden xl:grid grid-cols-3 gap-x-7 z-[1] relative mt-24">
          {props.facility.map((facility) => {
            return (
              <div key={facility.id}>
                <img
                  src={facility.thumbnail}
                  alt=""
                  className="rounded-[20px] object-cover h-[20rem]"
                  loading="lazy"
                />
                <h5
                  className="text-white text-3xl my-3.5 font-pluto"
                  dangerouslySetInnerHTML={{ __html: facility.title }}
                ></h5>
                <p
                  className="text-white text-xl"
                  dangerouslySetInnerHTML={{ __html: facility.description }}
                ></p>
              </div>
            );
          })}
        </div>

        <Carousel
          opts={{ loop: true }}
          plugins={[
            Autoplay({
              delay: 5000,
            }),
          ]}
          className="px-14 block xl:hidden mt-10"
        >
          <CarouselContent>
            {props.facility.map((facility) => {
              return (
                <CarouselItem key={facility.id}>
                  <img
                    src={facility.thumbnail}
                    alt=""
                    height={261}
                    className="rounded-[9px] object-cover w-full h-[261px]"
                  />
                  <h5
                    className="text-white xl:text-3xl my-3.5 font-pluto text-center"
                    dangerouslySetInnerHTML={{ __html: facility.title }}
                  ></h5>
                  <p
                    className="text-white text-[13px] xl:text-xl whitespace-normal text-center"
                    dangerouslySetInnerHTML={{ __html: facility.description }}
                  ></p>
                </CarouselItem>
              );
            })}
          </CarouselContent>

          <CarouselPrevious className="size-5 xl:size-10 left-5 top-1/3 bg-transparent cursor-pointer text-white z-10 border-2 !border-white" />
          <CarouselNext className="size-5 xl:size-10 right-5 top-1/3 bg-transparent cursor-pointer text-white z-10 border-2 border-white" />
        </Carousel>
      </div>
    </div>
  );
}
